import { createFileRoute } from "@tanstack/react-router";
import TermsAndConditions from "@/pages/TermsAndConditions";
import { buildBreadcrumbLd } from "@/lib/structured-data";

export const Route = createFileRoute("/_sticky/terms-and-conditions")({
  head: () => ({
    meta: [
      { title: "Trail Pass Terms & Conditions - Gatlinburg Wine Trail" },
      { name: "description", content: "Terms and conditions for the Gatlinburg Wine Trail VIP Trail Pass, including activation windows and completion rules." },
      { property: "og:title", content: "Trail Pass Terms & Conditions - Gatlinburg Wine Trail" },
      { property: "og:description", content: "Terms and conditions for the Gatlinburg Wine Trail VIP Trail Pass, including activation windows and completion rules." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://demo.gatlinburgwinetrail.com/terms-and-conditions" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Trail Pass Terms & Conditions - Gatlinburg Wine Trail" },
      { name: "twitter:description", content: "Terms and conditions for the Gatlinburg Wine Trail VIP Trail Pass, including activation windows and completion rules." },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbLd([{ name: "Terms & Conditions", path: "/terms-and-conditions" }]),
        ),
      },
    ],
    links: [{ rel: "canonical", href: "https://demo.gatlinburgwinetrail.com/terms-and-conditions" }],
  }),
  component: TermsAndConditions,
});
